import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import "./style.scss";

function ButtonCloseSpy() {
  const { t } = useTranslation();

  return (
    <div className="button-close-spy-container">
      <Link
        className="btn btn-primary"
        to={{
          pathname: "/chats",
          state: {
            spyConversationId: null,
            isByManager: false,
          },
        }}
      >
        <i className="bx bx-arrow-back"></i>
      </Link>

      <h4>{t("Ticket details")}</h4>
    </div>
  );
}

export default ButtonCloseSpy;
